import { useQuery } from '@apollo/client';
import useBusinessConfiguration from '../../../../../../hooks/useBusinessConfiguration';
import GET_UPSELL_PRODUCTS from './GET_UPSELL_PRODUCTS';
var useUpsellByCategories = function () {
    var _a;
    var program = useBusinessConfiguration().program;
    var data = useQuery(GET_UPSELL_PRODUCTS, {
        variables: { program: program },
        errorPolicy: 'ignore',
    }).data;
    var layout = data === null || data === void 0 ? void 0 : data.me.layout;
    return {
        upsellContent: layout === null || layout === void 0 ? void 0 : layout.landingUpsellContent,
        upsellProductModalContent: layout === null || layout === void 0 ? void 0 : layout.landingUpsellProductModalContent,
        products: (_a = data === null || data === void 0 ? void 0 : data.me.subscriptionProgram) === null || _a === void 0 ? void 0 : _a.products,
    };
};
export default useUpsellByCategories;
